<template>
  <div id="content" class="pageDataPolicy">
    <div class="container">
      <div class="pageDataPolicyContent">
        <div class="" v-html="termsandconditions">

        </div>
    </div>
  </div>
  </div>
</template>
<script>
 import {toast } from 'vue-sonner'
 import api from '@/tools/api';
// Add fonts to whitelist


export default {
  components: {

    // AddSomeThingLink
    // Toaster,
    // BookACall
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      termsandconditions :'',
            pageInfo: {
        mainTitle : "Terms and Conditions",
      },


    }
  },
  methods:{

  },
  computed:{

  },

  mounted(){
    this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
    api.get(process.env.VUE_APP_API_URL+"/termsandconditions").then( (r) => {
      console.log(r);
      this.termsandconditions = r.data.termsandconditions;
    }).catch( (e) => {
      console.log(e);
       toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
     });
  }
}
</script>
<style scoped >
.pageDataPolicy{
  padding-top:50px;
  padding-bottom: 50px;
}
.pageDataPolicyContent{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
padding: 50px;
margin-bottom: 50px;

}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
</style>

<style media="screen">
  .ql-editor{
    min-height:400px;
  }

</style>
